import useEntity from 'core/hooks/useEntity'

const useInteraction = (...args) => useEntity('interactions', ...args)
export default useInteraction
